<h3 *ngIf="news$ && (news$ | async)?.length">Local News</h3>
<app-country-news-item *ngFor="let item of news$ | async" [item]="item"></app-country-news-item>
